<fieldset
  appDragDrop
  class="additionalInfoFieldSet additinalInfoMatric"
  (fileDropped)="onFileDrop($event)"
>
  <legend>{{ fieldLabel | titlecase }}</legend>
  @if (!file) {
    <section class="uploadFilesSection">
      <label class="dragToUpload" for="fileInput">
        Drag Files to Upload (2MB maximum)
      </label>
      <span class="or">or</span>
      <button mat-flat-button class="browseFiles" (click)="fileUpload.click()">
        Browse Files
      </button>
    </section>
  }

  <input
    type="file"
    class="fileInput"
    (change)="onFileSelected($event)"
    accept=".jpg, .png, .pdf"
    [size]="maxFileSize.FILE_SIZE"
    #fileUpload
  />

  @if (file) {
    <p class="successfullUpload">File Successfully Uploaded!</p>
  }
  @if (file) {
    <mat-basic-chip class="afterFileSelected">
      <section class="matChipItem" [title]="file.name">
        <mat-icon class="attachFile matChipItem">attach_file</mat-icon>
        {{ fileName }}
        <mat-icon (click)="onFileRemove()" class="close matChipItem"
          >close</mat-icon
        >
      </section>
    </mat-basic-chip>
  }
</fieldset>
@if (maxFileSizeExceeded) {
  <mat-error class="mat-error">
    {{ maxFileSize.ERROR }}
  </mat-error>
}
